module.exports = __webpack_public_path__ + "static/media/8x10no2-min.2656e0ca.jpg";